import { render, staticRenderFns } from "./Infomation.vue?vue&type=template&id=218b8e42&scoped=true"
import script from "./Infomation.vue?vue&type=script&lang=js"
export * from "./Infomation.vue?vue&type=script&lang=js"
import style0 from "./Infomation.vue?vue&type=style&index=0&id=218b8e42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b8e42",
  null
  
)

export default component.exports